import React from 'react'

import FromCompanyLogoOrName from '@/components/misc/ReferralESignature/components/FromCompanyLogoOrName'
import AddressBlock from '@/components/misc/ReferralESignatureConsentPdf/components/AddressBlock'
import PdfSection from '@/components/misc/ReferralESignatureConsentPdf/components/PdfSection'
import { ReferralWithESignatureDetailsItem } from '@/types/responses/referrals'

interface Props {
  referral: ReferralWithESignatureDetailsItem
}

const HeaderSection: React.FC<Props> = ({ referral }) => {
  const { client } = referral

  return (
    <PdfSection>
      <header className="mb-4 flex justify-between gap-12">
        <FromCompanyLogoOrName
          company={referral.fromCompany}
          className="mb-12"
        />
        <AddressBlock referral={referral} />
      </header>

      <div className="mb-6">
        <p>
          {client.fullNameAndPartyName || client.fullName}
          {!!client.clientId && (
            <>
              <br />
              {client.clientId}
            </>
          )}
        </p>
      </div>

      <div className="mb-4">
        <p>
          Subject:{' '}
          <strong>
            {referral.serviceAreaString || '[Advice area]'} - Introduction
          </strong>
        </p>
      </div>
    </PdfSection>
  )
}

export default HeaderSection
